export default "__VITE_ASSET__CGQH$Dww__"